// [AI GENERATED CODE] Updated to TanStack Query v5 object syntax
import { QueryClient } from "@tanstack/react-query";
import graphqlApiHandler from "../utils/graphql-api-handler";

const queryClient = new QueryClient();

export function queryProfile(variables) {
  // [AI GENERATED CODE] Updated to React Query v5 object syntax
  return queryClient.fetchQuery({
    queryKey: ['profile'],
    queryFn: graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
      `query ($userId: String!) {
      userProfile(userId: $userId) {
          id
          userId
          stars
          coins
          level
          starsPrevLevel
          starsNextLevel
          playData {
            daysPlayed
            timeSpent
            dailyActivityMap
          }
          rewardsHistory {
            previousDayBasedQuestBadgeAchievedOrdering
            previousTimeBasedQuestBadgeAchievedOrdering
            previousWeeklyQuestBadgeAchievedOrdering
            previousWeeklyQuestBadgeAchievedDateTimeUTC
            daysCoinsWereAwarded
          }
          weeklyGoal {
             days
             duration
          }
      }
    }`,
      variables
    ),
  });
}

export function queryBadges() {
  // [AI GENERATED CODE] Updated to React Query v5 object syntax
  return queryClient.fetchQuery({
    queryKey: ['queryList'],
    queryFn: graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
      `{
      badges {
          url
          name
          type
          ordering
          milestone
          threshold
          code
          version
        }
      }
    `
    ),
  });
}

export function queryUserBadge(variables) {
  // [AI GENERATED CODE] Updated to React Query v5 object syntax
  return queryClient.fetchQuery({
    queryKey: ['userBadge'],
    queryFn: graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
      `query ($userId: String!) {
      userBadges(userId: $userId) {
        userId
        badge {
          url
          name
          type
          ordering
          milestone
          threshold
          code
          version
        }
        state
        weeklyGoalWhenBadgeAwarded {
          days
          duration
        }
        achievementDateTimeUTC
      }
    }
    `,
      variables
    ),
  });
}

export function updateUserGoal(variables) {
  // [AI GENERATED CODE] Updated to React Query v5 object syntax
  return queryClient.fetchQuery({
    queryKey: ['updateUserGoal'],
    queryFn: graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
      `mutation ($userProfileInput: UserProfileInput!) {
      editUserProfile(userProfileInput: $userProfileInput) {
        id
        userId
        stars
        coins
        level
        starsPrevLevel
        starsNextLevel
        weeklyGoal {
          days
          duration
        }
      }
    }
    `,
      variables
    ),
  });
}

export function updateSeenBadges(variables) {
  // [AI GENERATED CODE] Updated to React Query v5 object syntax
  return queryClient.fetchQuery({
    queryKey: ['updateUserBadge'],
    queryFn: graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
      `mutation (
      $userBadgeInputList: UserBadgeInputList!
      ) {
      editUserBadgeState(userBadgeInputList: $userBadgeInputList) {
        userId
        badge {
          code
        }
        state
      }
    }
    `,
      variables
    ),
  });
}
